import { render, staticRenderFns } from "./AlbumPreviewer.vue?vue&type=template&id=601fda1c&scoped=true&"
import script from "./AlbumPreviewer.vue?vue&type=script&lang=js&"
export * from "./AlbumPreviewer.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPreviewer.vue?vue&type=style&index=0&id=601fda1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601fda1c",
  null
  
)

export default component.exports